/* global document */

import ReactDOM from 'react-dom';

import { useComponentWillMount } from 'common/helpers/hooks';
import { useLocalization } from 'redux/localization/utils/hooks';

const InvalidGateway = () => {
  const { t } = useLocalization();
  useComponentWillMount(() => {
    document.getElementsByTagName('BODY')[0].innerHTML = '';
  });

  return ReactDOM.createPortal(
    <div className="c7-message c7-message--alert-error" role="alert">
      <svg
        aria-hidden="true"
        focusable="false"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      {t('general.errorMessages.invalidGateway')}
    </div>,
    document.getElementsByTagName('BODY')[0]
  );
};

export default InvalidGateway;
